import HRMSApp from './hrms-system';
export default HRMSApp;